<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M7 29v-6h8v6H7zm10-6V7h14v22H17v-6zm14 8H17v10h14V31zm2 10V31h8v10h-8zm0 3H6a2 2 0 01-2-2V6a2 2 0 012-2h36a2 2 0 012 2v36a2 2 0 01-2 2h-9zm0-37v6h8V7h-8zm0 8v6h8v-6h-8zm0 8h8v6h-8v-6zm-18-2v-6H7v6h8zm0-14v6H7V7h8zm0 34V31H7v10h8zm12-26h-6v6h6v-6zm-6-2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2v-8a2 2 0 00-2-2h-6z"/></svg>